/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceName
 */
export interface ServiceName {
    /**
     * 
     * @type {number}
     * @memberof ServiceName
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceName
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof ServiceName
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ServiceName
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ServiceName
     */
    readonly leaksCount: string;
}

/**
 * Check if a given object implements the ServiceName interface.
 */
export function instanceOfServiceName(value: object): value is ServiceName {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('leaksCount' in value) || value['leaksCount'] === undefined) return false;
    return true;
}

export function ServiceNameFromJSON(json: any): ServiceName {
    return ServiceNameFromJSONTyped(json, false);
}

export function ServiceNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'leaksCount': json['leaks_count'],
    };
}

  export function ServiceNameToJSON(json: any): ServiceName {
      return ServiceNameToJSONTyped(json, false);
  }

  export function ServiceNameToJSONTyped(value?: Omit<ServiceName, 'id'|'created_at'|'updated_at'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

